module.exports = __webpack_public_path__ + "static/img/computer1.5877bc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/computer1.jpg
// module id = +Zpw
// module chunks = 0